/**
 * Filters CPT multi-order save targets when mapped sibling statuses are present.
 * @module filterCptUpdateOrderIds
 */
import { SiblingOrder } from "../../../../../data-model/siblingOrdersModel";
import {
  CPT_SIBLING_STATUS_MAPPINGS,
  CptSiblingStatusMapping,
  payloadHasMappedSiblingStatus,
} from "./cptSiblingStatusMappings";
import { isLaterDateOfService } from "./isLaterDateOfService";

/**
 * Drops same/earlier-DOS siblings when the payload includes a mapped
 * `current_status`. Parent order is always retained.
 *
 * @param orderIdsToUpdate - Resolved parent + selected sibling order ids
 * @param parentOrderId - Current order being edited
 * @param parentDateOfService - Parent order date of service
 * @param jCodes - J-code rows from the CPT payload
 * @param siblings - Optional sibling orders for resolving sibling DOS
 * @param mappings - Parent → sibling status map entries
 * @returns Order ids that should receive a CPT tables POST
 */
export const filterCptUpdateOrderIds = (
  orderIdsToUpdate: string[],
  parentOrderId: string,
  parentDateOfService: string | undefined,
  jCodes: { auth_status?: string }[] | undefined,
  siblings?: SiblingOrder[],
  mappings: CptSiblingStatusMapping[] = CPT_SIBLING_STATUS_MAPPINGS,
): string[] => {
  if (!payloadHasMappedSiblingStatus(jCodes, mappings)) {
    return orderIdsToUpdate;
  }

  return orderIdsToUpdate.filter((targetOrderId) => {
    if (targetOrderId === parentOrderId) {
      return true;
    }

    const siblingDos = siblings?.find(
      (sibling) => sibling.order_id === targetOrderId,
    )?.order?.payload?.date_of_service;

    return isLaterDateOfService(parentDateOfService, siblingDos);
  });
};
